import type { PresenceSaveState } from '../../../lib/agent-presence-api';

/**
 * The polling-agent save, reported on the submission screen. It is deliberately a separate
 * line from the result's own status: the result was accepted whatever this says, and the
 * copy must never let a presence failure read as a result failure.
 */
export const PresenceSaveNotice = ({ state, onRetry }: { state: PresenceSaveState; onRetry: () => void }) => {
	if (state.status === 'idle') return null;

	if (state.status === 'saving') {
		return (
			<div
				className='pa-notice pa-notice--working'
				role='status'
			>
				<span
					className='pa-notice__dot'
					aria-hidden='true'
				/>
				<p className='pa-notice__text'>Saving polling agents…</p>
			</div>
		);
	}

	if (state.status === 'saved' || state.status === 'unchanged') {
		return (
			<div
				className='pa-notice pa-notice--ok'
				role='status'
			>
				<span
					className='pa-notice__dot'
					aria-hidden='true'
				/>
				<p className='pa-notice__text'>
					{state.status === 'saved'
						? `Polling agents saved — ${state.present} present, ${state.absent} with no agent.`
						: 'Polling agents already up to date.'}
				</p>
			</div>
		);
	}

	return (
		<div
			className='pa-notice pa-notice--failed'
			role='alert'
		>
			<span
				className='pa-notice__dot'
				aria-hidden='true'
			/>
			<div className='pa-notice__body'>
				<p className='pa-notice__text'>
					<strong>Polling agents not saved.</strong> Your result was submitted. {state.error.message}
				</p>
				{state.error.retryable ? (
					<button
						type='button'
						className='pa-notice__retry'
						onClick={onRetry}
					>
						Retry
					</button>
				) : null}
			</div>
		</div>
	);
};

export default PresenceSaveNotice;
